import React from 'react';
import { useTranslation } from 'react-i18next';
import clsx from 'clsx';

import scss from './MessageCard.module.scss';

const CardMark = ({ isManual, isNew, isGenerated, isCompressed }) => {
  const { t } = useTranslation('scout');

  return (
    <div className={scss.marksWrapper}>
      {isNew ? <div className={clsx(scss.mark, scss.markNew)}>{t('new')}</div> : null}
      {isManual ? <div className={clsx(scss.mark, scss.markManual)}>{t('manual')}</div> : null}
      {isGenerated ? <div className={clsx(scss.mark, scss.markGenerated)}>{t('generated')}</div> : null}
      {isCompressed ? <div className={clsx(scss.mark, scss.markCompressed)}>{t('compressed')}</div> : null}
    </div>
  );
};

export default CardMark;
